import Entity from './entity'
export default class OrderManagement extends Entity<number>{
    
    type:number;
    wtid :number;
    ordertime:Date;
    status:number=2;   
    cid:number;
    operators:string;
    weight:Number;
    orderno:string;
    updatetime:Date;
    updatetime1:Date;
    operators1:string;
}